import { lazy } from 'react';

const SuccessPayment = lazy(() =>
  import(/* webpackChunkName: "SuccessPaymentDesktop" */ '@common2/SuccessPayment/SuccessPayment')
);

export default SuccessPayment;
